import {
  DRAWING_TOOL_DEFAULT_FONT_COLOR_PRIMARY, DrawingTool,
} from '../../../../../drawingTool/drawingTool.enums';
import { type DrawingSettingsAction } from '../drawingSettings.action';
import { DRAWING_SETTINGS_SET_SETTINGS } from '../drawingSettings.actionTypes';
import { type DrawingTextSettingsState } from './drawingTextSettings.state';

export const drawingTextSettingsInitialState: DrawingTextSettingsState = {
  scalesWithMapZoom: true,
  fontSize: 20,
  fontColor: DRAWING_TOOL_DEFAULT_FONT_COLOR_PRIMARY,
};

export const drawingTextSettingsReducer = (
  state = drawingTextSettingsInitialState, action: DrawingSettingsAction
): DrawingTextSettingsState => {
  switch (action.type) {
    case DRAWING_SETTINGS_SET_SETTINGS: {
      if (action.payload.drawingTool !== DrawingTool.Text) {
        return state;
      }

      return {
        ...state,
        ...action.payload.settings.text,
      };
    }

    default:
      return state;
  }
};
